import React from 'react';
import useLoseBasic from '@/hooks/preload/useLoseBasic';
import { LoseBasic } from '@/providers/ReadyProvider';

interface LostAndFoundContextValue {
  loading: boolean;
  loseBasic: LoseBasic;
}

export const LostAndFoundContext = React.createContext<LostAndFoundContextValue>(null);

const LostAndFound = ({ children }: { children: React.ReactNode }) => {
  const { data: loseBasicData, loading: loseBasicLoading } = useLoseBasic();

  return (
    <LostAndFoundContext.Provider
      value={{
        loading: loseBasicLoading,
        loseBasic: loseBasicData,
      }}
    >
      {children}
    </LostAndFoundContext.Provider>
  );
};

export default LostAndFound;
